import { render, staticRenderFns } from "./tiscResults.vue?vue&type=template&id=252bb6c8&scoped=true&"
import script from "./tiscResults.vue?vue&type=script&lang=js&"
export * from "./tiscResults.vue?vue&type=script&lang=js&"
import style0 from "./tiscResults.vue?vue&type=style&index=0&id=252bb6c8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "252bb6c8",
  null
  
)

export default component.exports